var React = require('react');

function VideoSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Icon_feather-play","data-name":"Icon feather-play","transform":"translate(1 1.011)"},React.createElement("path",{"id":"Path_597","data-name":"Path 597","d":"M574.7,892.2v14.537c0,.422.666.633,1.054.335l9.49-7.268a.4.4,0,0,0,0-.669l-9.49-7.269C575.364,891.564,574.7,891.775,574.7,892.2Z","transform":"translate(-574.698 -891.722)","fill":"none","stroke":"#f40","strokeMiterlimit":"10","strokeWidth":"2"})));
}

VideoSmall.defaultProps = {"width":"12.726","height":"17.508","viewBox":"0 0 12.726 17.508"};

module.exports = VideoSmall;

VideoSmall.default = VideoSmall;
